import React from 'react';
import PropTypes from 'prop-types';
import { RichTextDisplay } from '@paypalcorp/donate-react';

function LandingRichTextDisplay({ campaignDescription }) {
  return (
    <RichTextDisplay
      id="campaign-description-preview"
      displayValue={campaignDescription}
    />
  );
}

LandingRichTextDisplay.propTypes = {
  campaignDescription: PropTypes.string,
};

export default LandingRichTextDisplay;
